<template>
    <section class="users-list">
        <div class="users-body">
            <div class="offer offer_pseudo" v-for="offer in 10" :key="offer">
                <div class="offer-avatar"></div>
                <div class="offer-wrap">
                    <p class="offer__name"></p>
                    <div class="offer-buttons">
                        <div class="button">
                        </div>
                        <div class="offer-decline"></div>
                    </div>
                </div>
                
            </div>
        </div>
    </section>
</template>
<script>
export default {
    name: 'OffersList'
}
</script>